export default __webpack_public_path__ + "static/media/ars-maquette-light-webfont.e0726bef.eot";